<app-season-base-form-header translationKey="salary-weight" [enableIcon]="enableIcon()" [(isDisabled)]="isDisabled" />
<form class="flex flex-col mb-4" [formGroup]="salaryWeight()">
    <div formArrayName="salaryWeights">
        <div class="grid grid-cols-2 gap-4">
            <div>
                <div class="flex flex-row justify-between text-[rgb(var(--ui-5))]">
                    <p>{{ 'seasons.season-creation.salary-weight.monthly-salary-column-label' | translate }}</p>
                    <p class="pr-4">{{ 'seasons.season-creation.salary-weight.weight-column-label' | translate }}</p>
                </div>
                @for (group of salaryWeight().get('salaryWeights')['controls']; track group; let i = $index) {
                    @if (i < 5) {
                        <div [formGroupName]="i" class="flex flex-col">
                            <app-weight-counter
                                [label]="salaryWeights[i].rangeLabel"
                                [formControl]="group.get('weight')"
                                [min]="0"
                                [max]="10"
                                [isDisabled]="isDisabled()"
                            ></app-weight-counter>
                        </div>
                    }
                }
            </div>
            <div>
                <div class="flex flex-row justify-between text-[rgb(var(--ui-5))]">
                    <p>{{ 'seasons.season-creation.salary-weight.monthly-salary-column-label' | translate }}</p>
                    <p class="pr-4">{{ 'seasons.season-creation.salary-weight.weight-column-label' | translate }}</p>
                </div>
                @for (group of salaryWeight().get('salaryWeights')['controls']; track group; let i = $index) {
                    @if (i >= 5) {
                        <div [formGroupName]="i" class="flex flex-col">
                            <app-weight-counter
                                [label]="salaryWeights[i].rangeLabel"
                                [formControl]="group.get('weight')"
                                [isDisabled]="isDisabled()"
                            ></app-weight-counter>
                        </div>
                    }
                }
            </div>
        </div>
    </div>
</form>
